
module.exports = function(a, b){
  var fn = function(){};
  fn.prototype = b.prototype;
  a.prototype = new fn;
  a.prototype.constructor = a;
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/_component-inherit@0.0.3@component-inherit/index.js
// module id = jmUK
// module chunks = 0